/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import Grid from "@mui/material/Grid";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";

// Vision UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Billing page components
import SecondaryUsers from "layouts/billing/components/SecondaryUsers";
import ExportReports from "layouts/billing/components/ExportReports";
import SalesOverview from "./components/SalesOverview";
import Sucursales from "./components/Sucursales";
import BancosUsados from "./components/BancosUsados";
import { useState, useEffect } from "react";

function Billing() {
  const [userType, setUserType] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (user && user.tipo) {
      setUserType(user.tipo);
    }
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox mt={4}>
        <VuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SecondaryUsers />
            </Grid>
            <Grid item xs={12} md={6}>
              <ExportReports />
            </Grid>
          </Grid>
        </VuiBox>
        
        {/* Show Sucursales only for business users */}
        {userType === "negocio" && (
          <VuiBox mb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Sucursales />
              </Grid>
            </Grid>
          </VuiBox>
        )}

        <VuiBox my={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <SalesOverview />
            </Grid>
          </Grid>
        </VuiBox>

        {/* Bancos Usados Section */}
        <VuiBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <BancosUsados />
            </Grid>
          </Grid>
        </VuiBox>
      </VuiBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Billing;
